import React from 'react';
import { Instagram, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_b51ca5cf-bc57-4be4-91f1-e0386a68d700/artifacts/sroy2sc2_WhatsApp%20Image%202026-03-14%20at%202.28.28%20AM.jpeg"
              alt="LTechSolutions" 
              className="footer-logo"
            />
            <p className="footer-tagline">
              Soluciones digitales modernas para negocios.
            </p>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>Uruguay</span>
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="footer-links">
            <h4 className="footer-links-title">Navegación</h4>
            <ul className="footer-links-list">
              <li>
                <button onClick={() => scrollToSection('hero')} className="footer-link">
                  Inicio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="footer-link">
                  Servicios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="footer-link">
                  Portfolio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="footer-link">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-links">
            <h4 className="footer-links-title">Servicios</h4>
            <ul className="footer-links-list">
              <li><span className="footer-link-static">Páginas web modernas</span></li>
              <li><span className="footer-link-static">Diseño responsive</span></li>
              <li><span className="footer-link-static">Menús digitales</span></li>
              <li><span className="footer-link-static">Optimización SEO</span></li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="footer-social-section">
            <h4 className="footer-links-title">Síguenos</h4>
            <div className="footer-social-links">
              <a
                href="https://instagram.com/ltechsolutions.uy"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-copyright-wrapper">
            <p className="footer-copyright">
              © {new Date().getFullYear()} LTechSolutions. Todos los derechos reservados.
            </p>
            <p className="footer-developed">
              Desarrollado por{' '}
              <a 
                href="https://www.ltechsolutions.dev" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-developed-link"
              >
                LTechSolutions
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
